import React from 'react';
import { Link } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCalendar, faCheckCircle, faHome, faIdCard, faLayerGroup, faListAlt, faListCheck, faListDots, faListOl, faQrcode, faUser, faUsers, faUserTie } from '@fortawesome/free-solid-svg-icons';
import './ThinkRent.css';
// import thinkrentimage from '../../assets/pageimages/ThinkRent.webp';


function ThinkRentHome() {
  const services = [
    { title: 'Bicycle', category: 'Bicycle', icon: 'fa-bicycle' },
    { title: 'Boat', category: 'Boat', icon: 'fa-ship' },
    { title: 'Camera Equipment', category: 'Camera Equipment', icon: 'fa-camera' },
    { title: 'Car', category: 'Car', icon: 'fa-car' },
    { title: 'Cargo', category: 'Cargo', icon: 'fa-ship' },
    { title: 'Catering Equipment', category: 'Catering Equipment', icon: 'fa-utensils' },
    { title: 'CCTV', category: 'CCTV', icon: 'fa-eye' },
    { title: 'Clothing', category: 'Clothing', icon: 'fa-tshirt' },
    { title: 'Computer', category: 'Computer', icon: 'fa-laptop' },
    { title: 'Construction Machinery', category: 'Construction Machinery', icon: 'fa-hammer' },
    { title: 'Costume', category: 'Costume', icon: 'fa-masks-theater' },
    { title: 'Co-working Space', category: 'Co-working Space', icon: 'fa-laptop-house' },
    { title: 'DJ Equipment', category: 'DJ Equipment', icon: 'fa-headphones' },
    { title: 'Drone', category: 'Drone', icon: 'fa-plane' },
    { title: 'Electrical Equipment', category: 'Electrical Equipment', icon: 'fa-plug' },
    { title: 'Event Equipment', category: 'Event Equipment', icon: 'fa-bullhorn' },
    { title: 'Fitness Equipment', category: 'Fitness Equipment', icon: 'fa-dumbbell' },
    { title: 'Furniture', category: 'Furniture', icon: 'fa-couch' },
    { title: 'Gardening Equipment', category: 'Gardening Equipment', icon: 'fa-leaf' },
    { title: 'Hall', category: 'Hall', icon: 'fa-hotel' },
    { title: 'Home Appliance', category: 'Home Appliance', icon: 'fa-tv' },
    // { title: 'Jet Ski', category: 'Jet Ski', icon: 'fa-water' },
    { title: 'Kayak/Canoe', category: 'Kayak/Canoe', icon: 'fa-water' },
    { title: 'Lorry', category: 'Lorry', icon: 'fa-truck' },
    { title: 'Luxury Car', category: 'Luxury Car', icon: 'fa-car-side' },
    { title: 'Luxury Handbag', category: 'Luxury Handbag', icon: 'fa-bag-shopping' },
    { title: 'Machine / Tools', category: 'Machine / Tools', icon: 'fa-wrench' },
    { title: 'Medical Equipment', category: 'Medical Equipment', icon: 'fa-stethoscope' },
    { title: 'Motorbike', category: 'Motorbike', icon: 'fa-motorcycle' },
    { title: 'Office Space', category: 'Office Space', icon: 'fa-building' },
    { title: 'Party Tent', category: 'Party Tent', icon: 'fa-campground' },
    { title: 'Playground', category: 'Playground', icon: 'fa-running' },
    { title: 'Portable Toilet', category: 'Portable Toilet', icon: 'fa-restroom' },
    { title: 'Power Tool', category: 'Power Tool', icon: 'fa-tools' },
    // { title: 'Quad Bike / ATV', category: 'ATV/Quad Bike', icon: 'fa-motorcycle' },
    { title: 'RV/Camper', category: 'RV/Camper', icon: 'fa-caravan' },
    // { title: 'Scooter', category: 'Scooter', icon: 'fa-motorcycle' },
    { title: 'Skateboard', category: 'Skateboard', icon: 'fa-skating' },
    { title: 'Smart Devices', category: 'Smart', icon: 'fa-brain' },
    // { title: 'Snowboard', category: 'Snowboard', icon: 'fa-snowboarding' },
    { title: 'Sound System', category: 'Sound System', icon: 'fa-volume-up' },
    { title: 'Surfboard', category: 'Surfboard', icon: 'fa-water' },
    { title: 'Tent', category: 'Tent', icon: 'fa-campground' },
    { title: 'Truck', category: 'Truck', icon: 'fa-truck-monster' },
    { title: 'Vacation Home', category: 'Vacation Home', icon: 'fa-home' },
    { title: 'Wedding Decor', category: 'Wedding Decor', icon: 'fa-ring' },
    { title: 'Yacht', category: 'Yacht', icon: 'fa-anchor' },  
];

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );
  

  return (
    <div className='text-black '>
      <div className="min-h-screen py-2 bg-black">
        <div className="flex flex-col p-2 border-b border-blue-400">
          <h2 className='text-lg lg:text-2xl font-bold text-yellow-200 text-center mb-2'>🏢 ThinkRental</h2>
          <p className='text-center text-white text-sm lg:text-lg'>Transforming Rentals With AI</p>          
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-2 place-items-center bg-black border-b border-blue-400 mb-2 p-2 rounded-lg shadow-lg items-center mt-2">
          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faHome} className="text-lg lg:text-xl mr-3" />
            <span>My Account</span>
          </Link>

          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faBolt} className="text-lg lg:text-xl mr-3" />
            <span>My Instant Need</span>
          </Link>

          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faCalendar} className="text-lg lg:text-xl mr-3" />
            <span>Scheduled Need</span>
          </Link>
          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faCheckCircle} className="text-lg lg:text-xl mr-3" />
            <span>I am Available</span>
          </Link>
          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faUserTie} className="text-lg lg:text-xl mr-3" />
            <span>Service Provider</span>
          </Link>

          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faLayerGroup} className="text-lg lg:text-xl mr-3" />
            <span>Digital Boutique</span>
          </Link>
        </div>        
        <div className="grid grid-cols-3 lg:grid-cols-8 gap-2">
          {services.map((service, index) => (
            <Link
              key={index}
              to={`/think-service-services-list/${service.category}`}
              className="block"
            >
              <div
                className="
                  flex flex-col items-center justify-center
                  h-20 lg:h-24 
                  w-full
                  bg-gray-800
                  border border-gray-700
                  rounded-xl
                  text-center
                  transition
                  hover:bg-cyan-600 hover:text-black
                  active:scale-95
                "
              >
                <i
                  className={`fas ${service.icon} text-2xl mb-2 text-blue-400`}
                ></i>

                <h2 className="text-xs lg:text-sm font-medium px-2 leading-tight line-clamp-2 text-white">
                  {service.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <footer className="bg-black text-white py-2 px-4 border-t border-blue-400">
        <div className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left">
          <p className="text-sm">&copy; 2026 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex space-x-6 mt-4 lg:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400 transition">Contact</Link>
          </div>
        </div>
      </footer>       
    </div>
  );
}

export default ThinkRentHome;



